import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-link-external-02',
  imports: [],
  templateUrl: './link-external-02.html',
  styleUrl: './link-external-02.scss',
})
export class LinkExternal02 {
  stroke = input<string>('#797674');
  width = input<string>('1rem');
  height = input<string>('1rem');
}
